import RequestApi from "../../utils/request";

export default {
	//获取元素
	GetLoginElement:(Data) => {
		// console.log(Data);
		///CMSAccount/Login
		var Url = '/M.C.Leung/System/Api/Login/GetLoginElement/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取系统元素
	GetSystemElement:(Data) => {
		// console.log(Data);
		///CMSAccount/Login
		var Url = '/M.C.Leung/System/Api/Login/GetSystemElement/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//获取验证码
	SendCode:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Login/SendCode/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//登录登录
	CheckIn:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Login/CheckIn/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	//退出系统
	CheckOut:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/System/Api/Login/CheckOut/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	
}